<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ params.title }}</div>
    <div slot="body">
       <a-form
        :form="form.fc">
        <a-form-item :label="params.price_type === 'amount' ? $t('scope.text_508') : $t('scope.text_509')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.price" :suffix="params.price_type === 'amount' ? (params.unit || '') : '%'" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_511')" v-bind="formItemLayout">
          <a-date-picker v-decorator="decorators.enable_time" :format="dateFormat" :disabledDate="disabledDate" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_512')" v-bind="formItemLayout">
          <a-textarea v-decorator="decorators.remark" :autoSize="{ minRows: 2, maxRows: 6 }" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'UpdateRateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        price: [
          'price',
          {
            initialValue: this.params.data ? this.params.price_type === 'amount' ? this.params.data[0].price : this.params.data[0].price * 100 : '',
            rules: [
              { required: true, message: this.$t('scope.text_513') },
            ],
          },
        ],
        enable_time: [
          'enable_time',
          {
            initialValue: this.params.data ? this.$moment(this.params.data[0].enable_time).format() : '',
            rules: [
              { required: true, message: this.$t('scope.text_514') },
            ],
          },
        ],
        remark: [
          'remark',
          {
            initialValue: this.params.data ? this.params.data[0].remark : '',
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      productList: [
        {
          name: this.$t('scope.text_515'),
          value: 'all',
        },
        {
          name: 'ECS',
          value: 'ecs',
        },
        {
          name: 'RDS',
          value: 'rds',
        },
        {
          name: 'CDN',
          value: 'cdn',
        },
      ],
      dateFormat: 'YYYY-MM-DD',
      resource_type: this.params.resourceType,
    }
  },
  computed: {
    ...mapGetters(['scope']),
    ...mapState('app', {
      customer: state => state.customer,
    }),
  },
  methods: {
    disabledDate (currentDate) {
      return currentDate && currentDate < this.$moment()
    },
    doCreate (data) {
      if (this.params.type === 'create') {
        return this.params.onManager('create', {
          managerArgs: {
            data,
          },
        })
      } else {
        return this.params.onManager('update', {
          id: this.params.data[0].id,
          managerArgs: {
            data,
          },
        })
      }
    },
    async handleConfirm () {
      this.loading = true
      try {
        let values = await this.form.fc.validateFields()
        values = {
          ...values,
          brand: this.params.brand,
          cloudaccount_id: this.params.cloudaccountId,
          resource_type: this.resource_type,
          domain_id: this.params.domain_id,
          price_type: this.params.price_type,
          price: this.params.price_type === 'amount' ? Number(values.price) : values.price / 100,
        }
        await this.doCreate(values)
        this.loading = false
        this.$message.success(this.$t('scope.text_521'))
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
